import { render, staticRenderFns } from "./UserBar.vue?vue&type=template&id=2519bfca&scoped=true&"
import script from "./UserBar.vue?vue&type=script&lang=js&"
export * from "./UserBar.vue?vue&type=script&lang=js&"
import style0 from "./UserBar.vue?vue&type=style&index=0&id=2519bfca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2519bfca",
  null
  
)

/* custom blocks */
import block0 from "./UserBar.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

component.options.__file = "UserBar.vue"
export default component.exports